var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 25,
    viewBox: "-8 0 56 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.82481 0.0374756H37.1041C38.1077 0.0374756 38.9289 0.900625 38.9289 1.95558V23.0544C38.9289 24.1094 38.1077 24.9725 37.1041 24.9725H1.82481C0.821167 24.9725 0 24.1094 0 23.0544V1.9555C0 0.900544 0.821167 0.0374756 1.82481 0.0374756Z",
    fill: "#DDDDDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.11607 5.79175H16.9064C17.6098 5.79175 18.1854 6.36715 18.1853 7.07048V8.98858C18.1853 9.69191 17.6098 10.2673 16.9063 10.2673H4.11607C3.41257 10.2673 2.83703 9.69191 2.83703 8.98858V7.07048C2.83703 6.36715 3.41257 5.79175 4.11607 5.79175ZM22.0224 5.79175H34.8127C35.5161 5.79175 36.0918 6.36715 36.0917 7.07048V8.98858C36.0917 9.69191 35.5161 10.2673 34.8126 10.2673H22.0224C21.3189 10.2673 20.7434 9.69191 20.7434 8.98858V7.07048C20.7434 6.36715 21.3189 5.79175 22.0224 5.79175Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.79635 14.423H17.2261C17.7697 14.423 18.1854 14.8705 18.1853 15.382C18.1853 15.9254 17.7696 16.341 17.2261 16.341H3.79635C3.2528 16.341 2.83711 15.9254 2.83711 15.382C2.83711 14.8386 3.2528 14.423 3.79635 14.423ZM3.79635 17.6198H11.4705C12.014 17.6198 12.4297 18.0674 12.4297 18.5788C12.4297 19.1222 12.014 19.5378 11.4705 19.5378H3.79635C3.2528 19.5378 2.83711 19.1222 2.83711 18.5788C2.83711 18.0354 3.2528 17.6198 3.79635 17.6198Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/card_icon.9ca8f73901910f28182fd898f1836d12.svg";
export { ForwardRef as ReactComponent };